import { useCallback, useMemo, useState } from 'react';
import {
  defaultTagColor,
  normalizeTagsAndColors,
} from '@/features/shared/components/entityDetails/EditableTagsSection.utils';
import type { TagColor } from '@/shared/data/tags';

type UseUploadTagDraftStateResult = {
  uploadTags: string[];
  uploadTagColors: TagColor[];
  uploadTagsInput: string;
  uploadTagValues: string[];
  setUploadTags: (value: string[]) => void;
  setUploadTagColors: (value: TagColor[]) => void;
  setUploadTagsInput: (value: string) => void;
  resetUploadTags: () => void;
};

export const useUploadTagDraftState = (): UseUploadTagDraftStateResult => {
  const [uploadTags, setUploadTags] = useState<string[]>([]);
  const [uploadTagColors, setUploadTagColors] = useState<TagColor[]>([]);
  const normalizedUploadTags = useMemo(
    () => normalizeTagsAndColors(uploadTags, uploadTagColors),
    [uploadTagColors, uploadTags],
  );
  const uploadTagsInput = useMemo(() => uploadTags.join(', '), [uploadTags]);
  const setUploadTagsInput = useCallback((value: string) => {
    const parsedTags = value.split(',').map((tag) => tag.trim());
    setUploadTags(parsedTags);
    setUploadTagColors((current) =>
      parsedTags.map((_tag, index) => current[index] ?? defaultTagColor),
    );
  }, []);

  const resetUploadTags = useCallback(() => {
    setUploadTags([]);
    setUploadTagColors([]);
  }, []);

  return {
    uploadTags,
    uploadTagColors,
    uploadTagsInput,
    uploadTagValues: normalizedUploadTags.tags,
    setUploadTags,
    setUploadTagColors,
    setUploadTagsInput,
    resetUploadTags,
  };
};
